// Author Lin
// Date 2021-08-27 10:02:26

import * as model from "@/model/sithMes/inventory/SithMesInventoryReceiptReturnRecordModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesInventoryReceiptReturnRecord(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_INVENTORY_URL,
    })
    .buildStore()
